import { render } from "./ad-group.vue?vue&type=template&id=701eb9ba&scoped=true"
import script from "./ad-group.vue?vue&type=script&lang=js"
export * from "./ad-group.vue?vue&type=script&lang=js"

import "./ad-group.vue?vue&type=style&index=0&id=701eb9ba&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701eb9ba"]])

export default __exports__